import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  type IListPublicChallengeClipsBySlugV1ResponseData,
  listPublicChallengeClipsBySlugV1ResponseSchema,
} from './list-public-challenge-clips-by-slug-v1-response';

/**
 * @deprecated Superseded by `listPublicChallengeClipsBySlugV2Api`. Frozen, not
 * deleted - an old app binary may still call it. See "Web-only / orphan versions
 * pending deletion" in apps/api/CLAUDE.md.
 */
export async function listPublicChallengeClipsBySlugV1Api(slug: string, limit?: number) {
  const query = limit ? `?limit=${limit}` : '';
  return getRequest<IAPI<IListPublicChallengeClipsBySlugV1ResponseData>>({
    path: `/challenges/v3/slug/${encodeURIComponent(slug)}/clips/v1${query}`,
    schema: listPublicChallengeClipsBySlugV1ResponseSchema,
  });
}
